import StubPage from '../../components/StubPage.jsx';

export default function EcommercePage() {
  return (
    <StubPage
      title="Commerce"
      description="Products, orders, subscriptions, and checkout for sites in this workspace."
      planned={[
        'Product catalog with images, variants, and inventory tracking',
        'Stripe Checkout + manual payment providers',
        'Subscriptions and recurring billing',
        'Coupons, discounts, and tax handling per region',
        'Order timeline, refunds, and fulfillment statuses',
      ]}
    />
  );
}
